import React from 'react';
import MDSpinner from 'react-md-spinner';
import { colors } from '../../editor/features/beta/styles/colors';

type Props = {
  show?: boolean;
  size?: number;
  position?: any;
  backgroundColor?: string;
  className?: string;
  color?: string;
  standalone?: boolean;
};

const Spinner = (props: Props) => {
  const { show, className, standalone } = props;
  const size = props.size || 24;
  let position = props.position || 'fixed';
  let backgroundColor = props.backgroundColor || 'rgba(0, 0, 0, 0.2)';
  let color = props.color || '#2f54eb';

  if (standalone) {
    color = colors.accentBlue;
    position = 'relative';
    backgroundColor = 'transparent';
  }

  const styleSheet = {
    flexContainer: {
      display: show || standalone ? 'flex' : 'none',
      position,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      zIndex: 1000,
      backgroundColor,
    },
  };

  return (
    // @ts-ignore
    <div style={styleSheet.flexContainer} className={className}>
      <MDSpinner size={size} singleColor={color} duration={1100} />
    </div>
  );
};

export default Spinner;
